import { createContext, useContext, useState } from "react";

export const TokenContext = createContext();

export const TokenProvider = (props) => {
    const [appKey, setAppKey] = useState("");
    const [appToken, setAppToken] = useState("");

    const handleChangeToken = (appkey, apptoken) => {
        setAppKey(appkey);
        setAppToken(apptoken);
    };

    return <TokenContext.Provider value={{ appKey, appToken, handleChangeToken }}>{props.children}</TokenContext.Provider>;
};

export const useToken = function () {
    return useContext(TokenContext);
};
